/* eslint-disable complexity */
import { useSelector } from 'react-redux';

import { PAYMENT_METHODS_SERVER } from '~constants/paymentMethods';
import { getPaymentMethod } from '~models/paymentMethods';
import { shoppingCartSelector, coreSettingsSelector } from '~screens/Dashboard/screens/Home/redux/selectors';
import { hyphensToCamelCase } from '~utils/functions';

import { renderPaymentMethod, disabledPaymentMethod, renderCashPaymentMethod } from './validations';

export const usePaymentMethodValidation = ({
  paymentMethods,
  isPapaCar,
  isHotspot,
  requestedTimeDispatch
}) => {
  const items = useSelector(state => state.home.shoppingCart.items || []);
  const shoppingCart = useSelector(shoppingCartSelector);
  const couponPaymentMethod = shoppingCart?.appliedPromos?.[0]?.appliedCoupon?.paymentMethod;
  const searchStore = useSelector(state => state.searchStore);
  const { externalDelivery, externalDeliveryCompany } = searchStore?.currentSubsidiary;
  const coreSettings = useSelector(coreSettingsSelector);

  const checkPaymentMethodCoupon = paymentKey => couponPaymentMethod || couponPaymentMethod === paymentKey;

  const checkCashLimitExternalDelivery = paymentKey => {
    const hasExternalDeliveryActivated = externalDelivery && externalDeliveryCompany;
    const cashLimit =
      paymentKey === PAYMENT_METHODS_SERVER.cash &&
      hasExternalDeliveryActivated &&
      coreSettings[`${hyphensToCamelCase(externalDeliveryCompany)}CashMaxAmount`];
    return cashLimit;
  };

  const shouldDisabledPaymentMethod = paymentKey => {
    const paymentMethod = getPaymentMethod(paymentKey);
    const isPaymentMethodDisabled =
      (!!requestedTimeDispatch && !paymentMethod?.isOnline) || disabledPaymentMethod(items)[paymentKey]?.();
    return couponPaymentMethod
      ? couponPaymentMethod !== paymentMethod?.name && couponPaymentMethod !== paymentMethod?.originalName
      : isPaymentMethodDisabled;
  };

  const shouldRenderPaymentMethod = paymentKey => {
    const paymentMethod = getPaymentMethod(paymentKey) ? { ...getPaymentMethod(paymentKey) } : null;
    const couponWithExclusivePayment = checkPaymentMethodCoupon(paymentKey);
    const cashLimit = checkCashLimitExternalDelivery(paymentKey);
    const isCashLimited = cashLimit ? shoppingCart.subtotal > cashLimit : false;
    if (!paymentMethod || isCashLimited) {
      return false;
    }
    if (isPapaCar && paymentKey === PAYMENT_METHODS_SERVER.credit) {
      return true;
    }
    const checkHotspot = isHotspot ? paymentMethod.isOnline : true;
    couponWithExclusivePayment === paymentKey && (paymentMethod.hide = false);
    return (
      paymentMethods[paymentKey] &&
      !paymentMethod.hide &&
      checkHotspot &&
      renderPaymentMethod(paymentKey, searchStore, shoppingCart)
    );
  };

  return paymentKey => ({
    render: shouldRenderPaymentMethod(paymentKey),
    disabled: shouldDisabledPaymentMethod(paymentKey),
    shouldRenderNoCashWarning:
      paymentKey === PAYMENT_METHODS_SERVER.cash && !renderCashPaymentMethod(searchStore, shoppingCart)
  });
};
